import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex } from "@chakra-ui/react";
import PageTitle from "../components/PageTitle";
import CreateTicketForm, { CreateTicketFormHandler } from "../components/forms/CreateTicketForm";
import PrimaryButton from "../components/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useCallback, useRef } from "react";
import { useMutation, useQueryClient } from "react-query";
import { createTicket } from "../mutations/ticket.mutations";
import { useSimpleToast } from "../hooks/toast.hooks";
import { useQueryParams } from "../hooks/utils.hooks";
import { useConnectedUser } from "../hooks/user.hooks";
import { useCenters } from "../hooks/centers.hooks";
import { Ticket } from "../types/ticket.types";

function TicketingCreatePage() {
  const { commandId, next } = useQueryParams()
  const user = useConnectedUser()
  const { center } = useCenters()
  const navigate = useNavigate()
  const formRef = useRef<CreateTicketFormHandler>(null)
  const queryClient = useQueryClient();
  const toast = useSimpleToast();
  const { mutate: mutateCreateTicket } = useMutation(createTicket, {
    onSuccess: (data: Ticket) => {
      queryClient.invalidateQueries(["command", "tickets"])
      toast.success('Ticket', 'Le ticket a été créé')
      if (typeof next === "string") {
        navigate(next)
        return;
      }
      navigate(`/tickets/${data.id}`)
      return;
    },
  })
  const handleSubmit = useCallback(async () => {
    if (formRef.current) {
      const valid = await formRef.current.valid();
      if (valid) {
        const values = formRef.current.values()
        if (user?.isSuperAdmin) {
          mutateCreateTicket({
            ticketLabelId: values.ticketLabelId,
            commandId: values.commandId,
            description: values.description,
            priority: values.priority,
            centerId: undefined,
            files: Array.from(values.files as File[])
          })
        } else {
          mutateCreateTicket({
            ticketLabelId: values.ticketLabelId,
            commandId: values.commandId,
            centerId: center?.id,
            description: values.description,
            priority: values.priority,
            files: Array.from(values.files as File[])
          })
        }
      }
    }
  }, [mutateCreateTicket, center?.id, user?.isSuperAdmin])
  return (
    <>
      <Breadcrumb
        spacing="8px"
        separator={<ChevronRightIcon color="gray.500" />}
      >
        <BreadcrumbItem>
          <BreadcrumbLink
            href="/tickets"
            color="gray.600"
            fontWeight={600}
            fontSize="14px"
          >
            Tickets SAV / Assistance
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink
            href="#"
            color="brand.700"
            fontWeight={600}
            fontSize="14px"
          >
            Nouveau ticket
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <PageTitle>Nouveau ticket</PageTitle>

      <Flex justifyContent={"center"}>
        <Box w={"50%"}>
          <CreateTicketForm ref={formRef} defaultValue={{
            commandId: Number.parseInt(commandId)
          }} editableDefault={false}></CreateTicketForm>

          <Flex gap={4} mt={4}>
            <Button w={'100%'} onClick={() => navigate('/tickets')}>Annuler</Button>
            <PrimaryButton onClick={handleSubmit}>Créer</PrimaryButton>
          </Flex>
        </Box>
      </Flex>
    </>
  );
}

export default TicketingCreatePage;
